export default __webpack_public_path__ + "static/media/banner.03cabc45.jpg";